import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '@app/app.config';
import { AppComponent } from '@app/app.component';
import { environment } from '@env/environment';
import { ENVIRONMENT_NAMES } from '@app/shared/constants/constants';

if (environment.environmentName !== ENVIRONMENT_NAMES.LOCAL) {
  Sentry.init({
    dsn: 'https://760cf1c38c9e451a2ece48a7fcbec501@o4507820179259392.ingest.de.sentry.io/4510033627185232',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    enableLogs: true,
    sendDefaultPii: true,
    environment: environment.environmentName,
  });
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
